import React from 'react';
import Typography from '@material-ui/core/Typography';
import { Link } from 'react-router-dom';
import { EDIT_PROFILE, PASSWORD_CHANGE } from '../../constants/routes';
import KobooButton from '../Layout/KobooButton';
import BikeIcon from '../Icon/BikeIcon';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => (
  {
    tableParent: {
      width: '100%',
      overflowX: 'auto',
      marginBottom: '2vh',
    },
    table: {
      minWidth: 700,
      textAlign: 'left',
    },
  }
));

const AccountOptions = (props) => {
  const classes = useStyles();

  return (
    <div>
      <Typography variant="h6" gutterBottom>Options</Typography>
      <div className={classes.tableParent}>
        <table className={classes.table}>
          <tbody>
          <tr>
            <th><Typography
              variant="subtitle1"
              gutterBottom>Éditer son profil
            </Typography>
            </th>
            <th>
              <KobooButton disabled={false} type="button" component={Link} to={EDIT_PROFILE}>
                <BikeIcon />
              </KobooButton>
            </th>
          </tr>
          <tr>
            <th><Typography
              variant="subtitle1"
              gutterBottom>Changer son mot de passe
            </Typography></th>
            <th>
              <KobooButton
                disabled={false}
                type="button"
                component={Link}
                to={PASSWORD_CHANGE}>
                <BikeIcon />
              </KobooButton>
            </th>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AccountOptions;



// WEBPACK FOOTER //
// ./src/components/Account/AccountOptions.jsx